import { useEffect, useLayoutEffect, useRef, useState } from 'react';

import { Affix, Flex, TableOfContents as MantineTableOfContents, Transition } from '@mantine/core';

import { HEADER_HEIGHT } from '@diagram/diagram-dimensions';

import { useScroll } from 'hooks/dom/use-scroll';

import cx from './TableOfContents.module.scss';

const TableOfContents = ({
    selector,
    reinit,
    top = HEADER_HEIGHT,
}: {
    reinit?: number;
    selector: string;
    top?: number;
}) => {
    const reinitializeRef = useRef(() => {});

    useLayoutEffect(() => {
        reinitializeRef.current();
    }, [reinit]);

    const { top: scroll } = useScroll();

    const [ref, setRef] = useState<Element | null>(null);

    useEffect(() => {
        const findRef = document.querySelector('[data-nav]');

        if (findRef) {
            setRef(findRef);
        }
    }, []);

    const scrollOffset = ref ? ref.getBoundingClientRect().top + ref.getBoundingClientRect().height + scroll : 200;

    const mounted = scroll > scrollOffset;

    const Content = (
        <MantineTableOfContents
            classNames={cx}
            reinitializeRef={reinit !== undefined ? reinitializeRef : undefined}
            scrollSpyOptions={{
                selector,
            }}
            getControlProps={({ data }) => ({
                onClick: () => data.getNode().scrollIntoView(),
                children: data.value,
            })}
        />
    );

    return (
        <>
            <Flex className={cx.container} justify="center" data-nav visibleFrom="md">
                {Content}
            </Flex>
            <Affix position={{ top, left: 0, right: 0 }} visibleFrom="md">
                <Transition transition="slide-down" mounted={mounted} exitDelay={50}>
                    {(transitionStyles) => (
                        <Flex className={cx.container} justify="center" style={transitionStyles} data-sticky>
                            {Content}
                        </Flex>
                    )}
                </Transition>
            </Affix>
        </>
    );
};

export { TableOfContents };
